import React, { useEffect, useState } from "react";
import {
  Dropdown,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Table,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../../features/save/saveSlice";
import TableLoading from "../../../../../components/TableLoading";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import svg12 from "../../../../../assets/svg/svg12.svg";

const EditableCell = ({
  seats,
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "money" ? (
      <InputNumber
        prefix={"KES"}
        min={1}
        id="input-focus"
        className="input"
        variant="borderless"
      />
    ) : (
      <Input id="input-focus" className="input" variant="borderless" />
    );
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          className="table-form-item"
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: false,
              message: `Field is required`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function SubsidizedBoqTable({ rowId, setRowId }) {
  const url = "api/v2/flid/boq/fetch";
  const urlTotal = "api/v2/flid/projects/getBoQTotals";
  const { loading, data, count, activeObjexpIsp } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    activeObjexpIsp: state.obj.activeObj["expressionIsp"],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate;
  const [form] = Form.useForm();

  const { activeObj, activeChama } = useSelector((state) => state.obj);
  const { groupMembers } = useSelector((state) => state.fetch);

  let seats = Array.from({ length: activeChama?.custSeat }, (v, k) => k + 1);

  const [editingKey, setEditingKey] = useState("");
  const [selectedObj, setselectedObj] = useState({});

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // const [rowId, setRowId] = useState([]);

  const handleEmployeeToReturns = async (selectedRows) => {
    setRowId(selectedRows);
  };

  const onSelectChange = (keys, rows) => {
    setSelectedRowKeys(keys);
    handleEmployeeToReturns(rows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const isEditing = (record) => record?.fpBoqId === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record?.fpBoqId);
  };

  const cancel = () => {
    setEditingKey("");
  };
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  async function handleFetch(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        fpbProjectBidId: activeObjexpIsp?.projectBidId,
      })
    );
  }

  const handleDelete = async () => {};

  const saveFunction = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item?.fpBoqId);
      if (index > -1) {
        const item = newData[index];

        const updatedObj = {
          ...item,
          ...row,
        };
        updatedObj.fpbProjectBidId = activeObjexpIsp?.projectBidId;
        const res = await dispatch(
          save({
            ...updatedObj,
            url: "api/v2/flid/boq/save",
          })
        );
        if (res?.payload?.success) {
          await handleFetch();
          await fetchBoqTotalsData()
          await toast.success(res?.payload?.message);
          await setEditingKey("");
        } else {
          toast.error(res?.payload?.message);
        }
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <div onClick={() => edit(selectedObj)} className="pointer w-full">
          Edit
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Item",
      dataIndex: "fpbItemName",
    },
    {
      title: "Quantity",
      dataIndex: "fpbQuantity",
    },
    {
      title: "@ Kes.",
      dataIndex: "fpbItemPrice",
    },
    {
      title: "Standardized Price @ Kes.",
      dataIndex: "fpbItemStandardPrice",
      editable: true,
    },
    {
      title: "SubTotal",
      dataIndex: "fpbItemSubtotal",
    },

    {
      title: "New SubTotal",
      dataIndex: "fpbSubtotalStandardPrice",
    },

    ...(activeObjexpIsp?.projectBidStatus === "SUBMITTED_FOR_STANDARDIZATION"
      ? [
          {
            title: "Action",
            dataIndex: "operation",
            render: (_, record) => {
              const editable = isEditing(record);
              return editable ? (
                <div className="flex w-fit items-center gap-[1rem]">
                  <button
                    onClick={cancel}
                    className="modal_btn_light"
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => saveFunction(record?.fpBoqId)}
                    className="modal_btn_dark"
                  >
                    Save
                  </button>
                </div>
              ) : (
                <button type="button" onClick={() => edit(record)}>
                  <img src={svg12} alt="svg12" />
                </button>
              );
            },
          },
        ]
      : []),
  ];

  const mergedColumns = columns?.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        inputType: col.dataIndex === "fpbItemStandardPrice" ? "money" : "text",
        title: col.title,
        editing: isEditing(record),
        seats: seats,
      }),
    };
  });

  useEffect(() => {
    handleFetch();
  }, []);

  useEffect(() => {}, [data]);

  async function fetchBoqTotalsData() {
    await dispatch(
      fetchData({
        url: urlTotal,
        projectBidId: activeObjexpIsp?.projectBidId,
        limit: null,
        start: 0,
      })
    );
  }

 

  return (
    <>
      <div className="grid grid-cols-1 gap-[1.25rem] pb-[1rem] mt-[1.69rem]  flex-1">
        <div className=" flex-col">
          {loading ? (
            <TableLoading />
          ) : (
            <Form form={form} component={false}>
              <Table
                rowSelection={false}
                className="mt-[1.25rem]"
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                rowKey={(record) => record?.fpBoqId}
                dataSource={data}
                columns={mergedColumns}
                scroll={{
                  x: "auto",
                }}
                pagination={{
                  position: ["bottomRight"],
                  current: pageIndex + 1,
                  total: count,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    handleFetch(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </Form>
          )}
        </div>
      </div>
    </>
  );
}
